@if (type() === RecruiteeLogoType.Signet) {
  <rt-recruitee-logo-signet></rt-recruitee-logo-signet>
} @else {
  <rt-recruitee-logo-full></rt-recruitee-logo-full>
}
